import { render, staticRenderFns } from "./TitleSlider.vue?vue&type=template&id=4873a811&"
import script from "./TitleSlider.vue?vue&type=script&lang=js&"
export * from "./TitleSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports